<template>
    <div style="width: 100%">
      <a-form  layout="inline"  >
        <a-form-item   label="户主姓名：" >
          <a-input style="width: 200px" v-model:value="formData.name" />
        </a-form-item>
        <a-form-item label="">
          <AreaCascader style="width: 400px" @loaded="onLoaded" ref="select" />
        </a-form-item>
        <a-form-item label="日期：">
          <a-range-picker
            :value="value"
            @change="onChange"
          />
<!--          @openChange="onOpenChange"-->
<!--          @calendarChange="onCalendarChange"-->
        </a-form-item>
        <a-form-item class="error-infos">
          <a-button type="primary" @click.prevent="onSubmit">查询</a-button>
          <a-button style="margin-left: 10px" @click="resetFields">重置</a-button>
          <a-button style="margin-left: 10px" @click="exportExcel">导出</a-button>
        </a-form-item>
      </a-form>
      <a-table ref="TableInfo"
               :columns="columns"
               :dataSource="dataSource"
               :pagination="pagination"
               :loading="loading"
               :scroll="{ x: 900 }"
               @change="handleTableChange">
              <template slot="remark" slot-scope="text, record">
                <a-popover placement="topLeft">
                  <template slot="content">
                    <div style="max-width: 200px">{{text}}</div>
                  </template>
                  <p style="width: 200px;margin-bottom: 0">{{text}}</p>
                </a-popover>
              </template>
            <template slot="operation" slot-scope="text, record">
              <a-button type="primary" @click="show(record)">查看</a-button>
            </template>
      </a-table>
      <a-modal v-model:visible="visible" :title="title">
<!--          <div class="fs17 sh_text">-->
<!--            <a-icon style="color: #3489FE" type="info-circle" theme="filled"></a-icon>-->
<!--            <span>点击编辑进入修改状态</span>-->
<!--          </div>-->
          <a-form  layout="vertical"  :label-col="{span:4}" :wrapper-col="{span:18}">
            <a-form-item style="margin-top: 10px">
              <span slot="label" class="sh_red">* 合格详情</span>
              <div class="flex a_i_c" style="cursor: pointer">
                <div :class="obj.result == 0 ?'a_left c_79':'a_left a_bg c_f'"  @click="obj.result = 1">合格</div>
                <div :class="obj.result == 1 ?'a_right c_79':'a_right a_bg c_f'" @click="obj.result = 0">不合格</div>
              </div>
            </a-form-item>
            <a-form-item  label="图片" >
              <a-upload
                :action="config.serverUrl+'?action=uploadimage'"
                listType="picture-card"
                :fileList="imgs"
                :beforeUpload="beforeUpload"
                @preview="handlePreview"
                @change="handleChange">
                <div v-if="imgs.length < 1">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">上传</div>
                </div>
              </a-upload>
            </a-form-item>
            <a-form-item   label="备注：" >
              <a-input
                type="textarea"
                :rows="2"
                placeholder="请输入内容"
                v-model="obj.remark">
              </a-input>
            </a-form-item>
          </a-form>

        <template slot="footer">
          <a-button key="back" @click="onClose">取消</a-button>
          <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">
            提交
          </a-button>
        </template>

      </a-modal>
    </div>
</template>
<script>
import AreaCascader from '@/components/select/AreaCascader'
import config from "../../config";
export default {
  name: 'sewageHome',
  components: {AreaCascader},
  data () {
    return {
      visible: false,
      imgs:[],
      title:'',
      value: [],
      formData: {
        pageNum: 1,
        pageSize: 10,
        name: '',
        streetId: '',
        sDate: '',
        eDate: ''
      },
      obj:{},
      config: {
        serverUrl: config.baseURL+'/ueditor/config'
      },
      dataSource: [],
      pagination: {
        pageSizeOptions: ['10', '20', '30', '40', '100'],
        defaultCurrent: 1,
        defaultPageSize: 10,
        showQuickJumper: true,
        showSizeChanger: true,
        showTotal: (total, range) => `显示 ${range[0]} ~ ${range[1]} 条记录，共 ${total} 条记录`
      },
      selectedRowKeys: [],
      loading: false,
      modelRef: {
        name: '',
        region: ''
      },
      imageUrl: '',
      textarea: ''
    }
  },
  computed: {
    columns () {
      return [
        {
          title: '序号',
          customRender:  (text, row, index) => {
            return index+1;
          }
        },
        {
          title: '户主姓名',
          dataIndex: 'name'
        },
        {
          title: '联系电话',
          dataIndex: 'phone'
        },
        {
          title: '商户名',
          dataIndex: 'memberTags'
        },
        {
          title: '地址',
          dataIndex: 'doorNo'
        },
        {
          title: '是否合格',
          dataIndex: 'result',
          customRender: (text, row, index) => {
            switch (Number(text)){
              case 0:
                return '不合格'
              case 1:
                return '合格'
            }
            return '-'
          }
        },
        {
          title: '巡检员',
          dataIndex: 'checkerName'
        },
        {
          title: '时间',
          dataIndex: 'createTime'
        },
        {
          title: '备注：',
          dataIndex: 'remark'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  methods: {
    onLoaded(e){
      console.log('e====',e)
    },
    handlePreview (file) {
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },
    show(o){
      this.obj = o
      let imgs = []
      let i = 0
      for (let img of JSON.parse(o.imgs)){
        imgs.push({url:img,status:'done', uid: i++,
          name: `xxx${i}.png`})
      }
      this.imgs = imgs

      this.title = `${o.name} ${o.createTime.split(" ")[0]} 巡检员：${o.checkerName}`
      this.visible = true
    },
    handleChange ({ fileList }) {
      this.imgs = fileList
    },
    onChange(e){
      if(e.length == 0){
        this.formData.sDate =''
        this.formData.eDate =''
        return
      }
      this.formData.sDate=e[0].format('YYYY-MM-DD') +" 00:00:00"
      this.formData.eDate=e[1].format('YYYY-MM-DD') +" 23:59:59"
      this.value=[e[0].format('YYYY-MM-DD'),e[1].format('YYYY-MM-DD')]
    },
    handleTableChange(pagination){
      this.formData.pageNum=pagination.current
      this.formData.pageSize=pagination.pageSize
      this.pagination = pagination;
      this.getList()
    },
    exportExcel () {
      let { filteredInfo} = this
      // 获取当前列的排序和列的过滤规则
      this.formData.streetId = this.$refs.select.getValue();
      this.$export('wsRecord/excel', {
        ...this.formData,
        ...filteredInfo
      },'xlsx')
    },
    resetFields(){
      let keys=Object.keys(this.formData)
      keys.map(item=>{
        if(item!='pageSize'){
          this.formData[item]=item=='pageNum'?1:''
        }
      })
      this.value=[]
      this.$refs.select.value=[]
      this.pagination.current=1
      this.pagination.current=1
      this.pagination.defaultCurrent=1
      this.getList()
    },
    handleSubmit(){
      if(this.imgs.length == 0){
        this.$message.error('请上传图片')
        return
      }
      this.obj.imgs=JSON.stringify(this.imgs.map(o => o.url || o.response.url))
      let o = {result:this.obj.result,imgs:this.obj.imgs,remark:this.obj.remark,id:this.obj.id}
      this.loading = true
      this.$post('wsRecord/update', o).then((r)=>{
        this.$message.success('修改成功')
        this.visible = false
        this.getList()
      })
    },
    onClose(){
      this.visible = false
    },
    onSubmit(){
      this.formData.pageNum=1;
      this.formData.streetId = this.$refs.select.getValue();
      console.log(this.formData)
      this.getList();
    },
    beforeUpload(file){
      const isImg = file.type.indexOf('image')>=0
      if (!isImg) {
        this.$message.error('只能上传图片文件')
      }

      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('Image must smaller than 2MB!')
      }
      return isImg && isLt2M
    },
    getList () {
      this.loading = true
      this.$get('wsRecord/list', this.formData).then((r)=>{
        let data = r.data
        const pagination = { ...this.pagination }
        pagination.total = data.total
        this.dataSource = data.rows
        this.pagination = pagination
        this.loading = false
      })
    },
    tableRowClassName ({row, rowIndex}) {
      if (rowIndex === 1) {
        return 'warning-row'
      } else if (rowIndex === 3) {
        return 'success-row'
      }
      return ''
    }
  }
}
</script>

<style scoped>
/deep/ .ant-modal-header{
  background: #DCDCDC;
}
.sh_text{
  width: 100%;
  height: 41px;
  background: #D5E5FA;
  border: 1px solid #3489FE;
  border-radius: 3px;
  line-height: 41px;
  padding: 0 24px;
  box-sizing: border-box;
}
.sh_red{
  color: #FF0000;
  font-size: 10px;
}
.flex{
  display: flex;
} .a_i_c{
  align-items: center;
  }
 .a_left,.a_right{
   height: 29px;
   width: 116px;
   text-align: center;
   line-height: 29px;
   font-size: 13px;
 }
 .c_f{
   color: #ffffff;
 }
 .c_79{
   color: #797979;
 }
 .a_left{
   border-radius: 10px 0px 0px 10px;
 }
 .a_right{
   border-radius: 0px 10px 10px 0px;
 }
 .a_bg{
   background: rgba(74,117,202,0.8);
 }
</style>



// WEBPACK FOOTER //
// src/views/sewage/sewageHome.vue